module.exports = __webpack_public_path__ + "af.svg?fcb7bc6ca1d1e85f6eb9940e64c5bca3";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/af.svg
// module id = 736
// module chunks = 27